import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=0fca081e&scoped=true&"
import script from "./Layers.vue?vue&type=script&lang=js&"
export * from "./Layers.vue?vue&type=script&lang=js&"
import style0 from "./Layers.vue?vue&type=style&index=0&id=0fca081e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca081e",
  null
  
)

export default component.exports